/**
 * Wraps a component in a scope element so its stylesheet only applies inside it.
 *
 * Create React App bundles every CSS file globally, so two files defining the same class
 * (".btn-back", ".form-group", ...) overrode each other depending on which page loaded first.
 * Each component stylesheet now prefixes its selectors with the scope class, e.g.
 * ":where(.scope-asset-details) .btn-back", and the component is exported through this wrapper.
 * :where() adds no specificity, so rules compete with Bootstrap and each other exactly as before.
 * The wrapper uses `display: contents` (see .css-scope in global.css), so it adds no box
 * and does not affect layout.
 *
 * A page can list extra scopes when it relies on another stylesheet, e.g. the dashboard uses
 * the button styles from styles/shared/Modal.css: withCssScope(Dashboard, 'scope-dashboard-layout scope-modal').
 */
const withCssScope = (Component, scope) => {
  const Scoped = (props) => (
    <div className={`css-scope ${scope}`}>
      <Component {...props} />
    </div>
  );
  Scoped.displayName = `withCssScope(${Component.displayName || Component.name || 'Component'})`;
  return Scoped;
};

export default withCssScope;
